import moment from "moment";

// Set default due date and time to one week from today at noon
const defaultDueDate = moment()
  .hour(12)
  .minute(0)
  .seconds(0)
  .add(7, "days");

// Setting up the default state for the container, so we can import it within
// the component itself as well as any tests

const defaultDevState = {
  userInput: {
    name: {
      val: "TEST",
      isValid: true
    },
    email: {
      val: "mnaylor@utk.edu",
      isValid: true
    },
    title: {
      val: "TEST",
      isValid: true
    },
    type: {
      val: "Choose one", // Must match the text in option element exactly
      isValid: true
    },
    sport: {
      val: "N/A"
    },
    due: {
      val: defaultDueDate
    },
    description: {
      val: "SOME DESCRIPTION",
      isValid: true
    }
  }
};

// Setting up the default state for the container, so we can import it within
// the component itself as well as any tests
const defaultState = {
  userInput: {
    name: {
      val: "",
      isValid: null
    },
    email: {
      val: "",
      isValid: null
    },
    title: {
      val: "",
      isValid: null
    },
    type: {
      val: "Choose one", // Must match the text in option element exactly
      isValid: null
    },
    sport: {
      val: "N/A"
    },
    due: {
      val: defaultDueDate // A moment() object
    },
    description: {
      val: "",
      isValid: null
    }
  }
};

export default (process.env.NODE_ENV === "development"
  ? defaultDevState
  : defaultState);



// WEBPACK FOOTER //
// ./src/Photo/config/defaultContainerState.js